<template>
  <settings-modal class="profile-fee-disable-modal">
    <template slot="heading">Disable fee?</template>

    <template>
      <v-select
        v-model="form.feeType"
        class="t-disable-fee-field"
        :items="disableOptions"
        item-text="name"
        item-value="value"
        disabled
        label="Fee to disable"
        :error-messages="getValidationErrorMessage('feeType')"
      />

      <date-picker
        v-model="form.frozenUntil"
        class="t-disable-fee-till-field"
        label="Disable till"
        clearable
        :min="minDateToDisable"
        :error-messages="getValidationErrorMessage('frozenUntil')"
      />

      <v-textarea
        v-model="form.reason"
        class="t-disable-fee-reason-field"
        label="Reason"
        hint="Required field"
        persistent-hint
        :error-messages="getValidationErrorMessage('reason')"
      />

      <error-alert :error="error" />
    </template>

    <template slot="actions">
      <v-btn
        id="t-confirm-disable"
        color="primary"
        medium
        flat
        :disabled="loading"
        @click="onConfirmButtonClick"
      >confirm</v-btn>

      <v-btn
        class="t-close-modal"
        color="primary"
        medium
        flat
        @click="onCloseButtonClick"
      >close</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Utils
  import { formatDate } from '@/utils/Date'

  // Events
  import { EVENT_FEE_DISABLE } from '@/events/fees'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import ProfileApi from '@/services/Api/ProfileApi'

  // Mixins
  import form from '@/mixins/form'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import DatePicker from '@/components/ui/DatePicker'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'ProfileFeeDisableModal',
    components: {
      SettingsModal,
      DatePicker,
      ErrorAlert
    },
    mixins: [form],
    data () {
      return {
        form: {
          feeType: null,
          frozenUntil: '',
          reason: null
        },
        profileFeeDisableApiRequest: new ApiRequest(ProfileApi.disableFee)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      profileId () {
        return this.modal.data.profileId
      },
      minDateToDisable () {
        return formatDate(new Date())
      },
      disableOptions () {
        return this.modal.data.disableOptions
      },
      loading () {
        return this.profileFeeDisableApiRequest.loading
      },
      error () {
        return this.profileFeeDisableApiRequest.error
      }
    },
    created () {
      this.form.feeType = this.modal.data.feeType
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onConfirmButtonClick () {
        this.profileFeeDisableApiRequest
          .execute(this.profileId, this.form)
          .then(this.profileFeeDisableSuccessHandler)
          .catch(() => {})
      },
      onCloseButtonClick () {
        this.closeModal()
      },
      profileFeeDisableSuccessHandler () {
        this.$eventHub.$emit(EVENT_FEE_DISABLE)
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: 'Fee has been successfully disabled.' }
          })
        }, 100)
      }
    }
  }
</script>
